import type { FC } from 'react';

import { Tooltip } from '@/components/ui/tooltip';
import { cls } from '@/utils/cls';
import { ComplianceStatus } from '@/warranty/domain/entities/compliance-status';

import {
  ComplianceStatusIcon,
  tooltipFromComplianceStatus,
} from './ComplianceStatusIcon';

type ComplianceStatusBadgeProps = {
  status: ComplianceStatus;
};

const labelFromComplianceStatus: Record<ComplianceStatus, string> = {
  [ComplianceStatus.NO_DATA]: 'No Data',
  [ComplianceStatus.COMPLIANT]: 'Compliant',
  [ComplianceStatus.NON_COMPLIANT]: 'Non-Compliant',
  [ComplianceStatus.AT_RISK]: 'At Risk',
};

const styleFromComplianceStatus: Record<ComplianceStatus, string> = {
  [ComplianceStatus.NO_DATA]: 'bg-gray-50 text-gray-700',
  [ComplianceStatus.COMPLIANT]: 'bg-green-50 text-green-700',
  [ComplianceStatus.NON_COMPLIANT]: 'bg-yellow-50 text-yellow-700',
  [ComplianceStatus.AT_RISK]: 'bg-orange-50 text-orange-700',
};

export const ComplianceStatusBadge: FC<ComplianceStatusBadgeProps> = ({
  status,
}) => (
  <Tooltip delay content={tooltipFromComplianceStatus[status]}>
    <span
      className={cls(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium',
        styleFromComplianceStatus[status],
      )}
    >
      <ComplianceStatusIcon status={status} />
      {labelFromComplianceStatus[status]}
    </span>
  </Tooltip>
);
